import GSAP from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

GSAP.registerPlugin(ScrollTrigger)

export default class Nav {
	constructor() {
		
		this.menuButtons 	= document.querySelectorAll('[data-nav]');
		this.openMenu		= this.openMenu.bind(this)

		// HANDLE CLICKS
		this.menuButtons && this.menuButtons.forEach((menuButton)=>{
			menuButton.addEventListener('click', this.openMenu )
		})

		/** 
		 * uncomment this line to add 'sticky nav', make sure to check first line for 'nav height' is correct
		 */
		this.sticky()
		
	}

	openMenu(event){
		const menuName 		= event.target.dataset.nav;
		document.querySelector('body').classList.toggle('nav--open')
		if(window.app.smoothScroll.lenis){
			if(window.app.smoothScroll.lenis.isStopped == true) {
				window.app.smoothScroll.lenis.start()
			} else {
				window.app.smoothScroll.lenis.stop()
			}
		}
	}

	sticky()
	{
		// HIDING NAV ON SCROLL USING GSAP
		this.showNavAnimation = GSAP.from(document.querySelector('header'), {
			yPercent: -110,
			paused: true,
			duration: 0.1
		}).progress(1);

		this.scrollHideStartDistance = '100px top'

		ScrollTrigger.create({
			start: this.scrollHideStartDistance,
			end: 999999,
			onUpdate: (self) => {
				if( self.direction === -1 ){
					if(document.querySelector('.page-template-default #what-we-do-menu')) {
						document.querySelector('#what-we-do-menu').classList.remove('what-we-do-menu--tucked')
					}
					this.showNavAnimation.play()
				} else {
					if(document.querySelector('.page-template-default #what-we-do-menu')) {
						document.querySelector('#what-we-do-menu').classList.add('what-we-do-menu--tucked')
					}
					this.showNavAnimation.reverse()
				}
			}
		});

	}	 
}
